import { useTranslation } from 'react-i18next'
import type { Item } from '~/shared/api'
import { getSalesSources } from '~/entities/products/lib'
import { ToolTip } from '~/shared/ui'

interface SiteSalesTooltipValueProps {
  value: number
  sources: Item['soldLastMonthSources']
}

export const SiteSalesTooltipValue = ({
  value,
  sources,
}: SiteSalesTooltipValueProps) => {
  const { t } = useTranslation(['products'])
  const sourceItems = getSalesSources(sources)

  return (
    <ToolTip
      tooltipText={
        <div className="space-y-1 text-xs">
          {sourceItems.map((source) => (
            <div
              key={source.labelKey}
              className="flex items-center justify-between gap-4"
            >
              <span className="text-[#707070]">{t(source.labelKey)}</span>
              <span className="text-[#242424]">{source.value}</span>
            </div>
          ))}
        </div>
      }
      wrapperClassName="block"
      minWidth="180px"
    >
      <div className="cursor-help">
        <span className="border-b border-dotted border-[#BDBDBD] leading-none">
          {value}
        </span>
      </div>
    </ToolTip>
  )
}
